import { EditorObject } from 'utils/responsiveTypes'

const tableListsInventoryTable: EditorObject = {
  x: 290,
  y: 21,
  id: '3yr2l0jhdskojb1vvb2ccfsad',
  name: 'Inventory Table',
  type: 'LAYOUT_SECTION',
  width: 1222,
  height: 410,
  hidden: false,
  mobile: {
    x: 0,
    y: 21,
    width: 1512,
    height: 550,
    pushGraph: {
      edges: [],
      nodeIds: ['esnwr18r5q0emmufvsyquw6nv'],
    },
    positioning: 'fixedTop',
    responsivity: {
      verticalScaling: 'FIXED',
      horizontalScaling: 'SCALES_WITH_PARENT',
      verticalPositioning: 'TOP',
      horizontalPositioning: 'LEFT_AND_RIGHT',
    },
  },
  shadow: {
    x: 0,
    y: 2,
    size: 4,
    color: '#00000020',
    enabled: true,
  },
  shared: {
    mobile: false,
    tablet: false,
    desktop: false,
  },
  tablet: {
    x: 0,
    y: 21,
    width: 1512,
    height: 436,
    pushGraph: {
      edges: [],
      nodeIds: ['esnwr18r5q0emmufvsyquw6nv'],
    },
    positioning: 'fixedTop',
    responsivity: {
      verticalScaling: 'FIXED',
      horizontalScaling: 'SCALES_WITH_PARENT',
      verticalPositioning: 'TOP',
      horizontalPositioning: 'LEFT_AND_RIGHT',
    },
  },
  actions: {},
  desktop: {
    x: 0,
    y: 21,
    width: 1512,
    height: 407,
    pushGraph: {
      edges: [],
      nodeIds: ['esnwr18r5q0emmufvsyquw6nv'],
    },
    positioning: 'fixedTop',
    responsivity: {
      verticalScaling: 'FIXED',
      horizontalScaling: 'SCALES_WITH_PARENT',
      verticalPositioning: 'TOP',
      horizontalPositioning: 'LEFT_AND_RIGHT',
    },
  },
  opacity: 1,
  children: [
    {
      x: 290,
      y: 59,
      id: 'esnwr18r5q0emmufvsyquw6nv',
      name: 'Layout Helper',
      type: 'section',
      width: 1222,
      height: 334,
      hidden: false,
      mobile: {
        x: 0,
        y: 61,
        width: 1512,
        height: 470,
        pushGraph: {
          edges: [],
          nodeIds: ['3ga1q74te62s71v9j2avobo1t'],
        },
        positioning: 'fixed',
        responsivity: {
          verticalScaling: 'FIXED',
          horizontalScaling: 'SCALES_WITH_PARENT',
          verticalPositioning: 'TOP',
          horizontalPositioning: 'CENTER',
        },
      },
      shadow: {
        x: 0,
        y: 2,
        size: 4,
        color: 'rgba(0, 0, 0, 0.2)',
        enabled: false,
      },
      shared: {
        mobile: false,
        tablet: false,
        desktop: false,
      },
      tablet: {
        x: 0,
        y: 47,
        width: 1512,
        height: 384,
        pushGraph: {
          edges: [],
          nodeIds: ['3ga1q74te62s71v9j2avobo1t'],
        },
        positioning: 'fixed',
        responsivity: {
          verticalScaling: 'FIXED',
          horizontalScaling: 'SCALES_WITH_PARENT',
          verticalPositioning: 'TOP',
          horizontalPositioning: 'CENTER',
        },
      },
      actions: {},
      desktop: {
        x: 0,
        y: 56,
        width: 1512,
        height: 337,
        pushGraph: {
          edges: [],
          nodeIds: ['3ga1q74te62s71v9j2avobo1t'],
        },
        positioning: 'fixed',
        responsivity: {
          verticalScaling: 'FIXED',
          horizontalScaling: 'SCALES_WITH_PARENT',
          verticalPositioning: 'TOP',
          horizontalPositioning: 'CENTER',
        },
      },
      opacity: 1,
      purpose: 'layout_helper',
      children: [
        {
          x: 501.00000000000364,
          y: 59,
          id: '3ga1q74te62s71v9j2avobo1t',
          name: 'Container',
          type: 'section',
          width: 800.0000000000052,
          height: 334,
          hidden: false,
          mobile: {
            x: 62.0307692307693,
            y: 61,
            width: 1387.9384615384633,
            height: 470,
            pushGraph: {
              edges: [],
              nodeIds: ['8a3goj4fxsjrxw8qbu20s6y6j'],
            },
            positioning: 'fixedTop',
            responsivity: {
              verticalScaling: 'FIXED',
              horizontalScaling: 'SCALES_WITH_PARENT',
              verticalPositioning: 'TOP',
              horizontalPositioning: 'CENTER',
            },
          },
          shadow: {
            x: 0,
            y: 2,
            size: 4,
            color: '#00000020',
            enabled: false,
          },
          shared: {
            mobile: false,
            tablet: false,
            desktop: false,
          },
          tablet: {
            x: 192.17266187050353,
            y: 47,
            width: 1127.6546762589928,
            height: 384,
            pushGraph: {
              edges: [
                {
                  distance: 16,
                  endNodeId: '8a3goj4fxsjrxw8qbu20s6y6j',
                  startNodeId: '7011ou39h5wwv63sx0k07dem7',
                },
              ],
              nodeIds: [
                '7011ou39h5wwv63sx0k07dem7',
                '8a3goj4fxsjrxw8qbu20s6y6j',
              ],
            },
            positioning: 'fixedTop',
            responsivity: {
              verticalScaling: 'FIXED',
              horizontalScaling: 'SCALES_WITH_PARENT',
              verticalPositioning: 'TOP',
              horizontalPositioning: 'CENTER',
            },
          },
          actions: {},
          desktop: {
            x: 261,
            y: 56,
            width: 990.0000000000007,
            height: 337,
            pushGraph: {
              edges: [
                {
                  distance: 13,
                  endNodeId: '8a3goj4fxsjrxw8qbu20s6y6j',
                  startNodeId: '7011ou39h5wwv63sx0k07dem7',
                },
              ],
              nodeIds: [
                '7011ou39h5wwv63sx0k07dem7',
                '8a3goj4fxsjrxw8qbu20s6y6j',
              ],
            },
            positioning: 'fixedTop',
            responsivity: {
              verticalScaling: 'FIXED',
              horizontalScaling: 'SCALES_WITH_PARENT',
              verticalPositioning: 'TOP',
              horizontalPositioning: 'CENTER',
            },
          },
          opacity: 1,
          purpose: 'container',
          children: [
            {
              x: 501.00000000000364,
              y: 60,
              id: '7011ou39h5wwv63sx0k07dem7',
              name: 'Rectangle  82',
              type: 'section',
              width: 800.0000000000082,
              height: 54,
              hidden: false,
              mobile: {
                x: 28.02051282051285,
                y: 30,
                width: 626.958974358974,
                height: 54,
                pushGraph: {
                  edges: [
                    {
                      distance: 0.75,
                      endNodeId: '9vux9ndrpy24jbiy4iuc9t5k7',
                      startNodeId: 'buffer_9vux9ndrpy24jbiy4iuc9t5k7',
                    },
                    {
                      distance: 1,
                      endNodeId: 'dk3rtqq8xd06vbkue3oynfnl0',
                      startNodeId: 'buffer_dk3rtqq8xd06vbkue3oynfnl0',
                    },
                    {
                      distance: 1,
                      endNodeId: '0x27jw14pzcftqj4zuajph9vf',
                      startNodeId: 'buffer_0x27jw14pzcftqj4zuajph9vf',
                    },
                  ],
                  nodeIds: [
                    '8t1zitypw7seplzhg9tghxanl',
                    'buffer_9vux9ndrpy24jbiy4iuc9t5k7',
                    '9vux9ndrpy24jbiy4iuc9t5k7',
                    'buffer_dk3rtqq8xd06vbkue3oynfnl0',
                    'dk3rtqq8xd06vbkue3oynfnl0',
                    'buffer_0x27jw14pzcftqj4zuajph9vf',
                    '0x27jw14pzcftqj4zuajph9vf',
                  ],
                },
                positioning: 'fixedTop',
                responsivity: {
                  verticalScaling: 'FIXED',
                  horizontalScaling: 'SCALES_WITH_PARENT',
                  verticalPositioning: 'TOP',
                  horizontalPositioning: 'CENTER',
                },
              },
              shadow: {
                x: 0,
                y: 2,
                size: 4,
                color: 'rgba(0, 0, 0, 0.2)',
                enabled: false,
              },
              shared: {
                mobile: false,
                tablet: true,
                desktop: true,
              },
              tablet: {
                x: 192.17266187050353,
                y: 48,
                width: 1127.654676258997,
                height: 54,
                pushGraph: {
                  edges: [
                    {
                      distance: 0.75,
                      endNodeId: '9vux9ndrpy24jbiy4iuc9t5k7',
                      startNodeId: 'buffer_9vux9ndrpy24jbiy4iuc9t5k7',
                    },
                    {
                      distance: 0.75,
                      endNodeId: '0x27jw14pzcftqj4zuajph9vf',
                      startNodeId: 'buffer_0x27jw14pzcftqj4zuajph9vf',
                    },
                    {
                      distance: 1,
                      endNodeId: 'dk3rtqq8xd06vbkue3oynfnl0',
                      startNodeId: 'buffer_dk3rtqq8xd06vbkue3oynfnl0',
                    },
                  ],
                  nodeIds: [
                    '8t1zitypw7seplzhg9tghxanl',
                    'buffer_9vux9ndrpy24jbiy4iuc9t5k7',
                    '9vux9ndrpy24jbiy4iuc9t5k7',
                    'buffer_0x27jw14pzcftqj4zuajph9vf',
                    '0x27jw14pzcftqj4zuajph9vf',
                    'buffer_dk3rtqq8xd06vbkue3oynfnl0',
                    'dk3rtqq8xd06vbkue3oynfnl0',
                  ],
                },
              },
              actions: {},
              desktop: {
                x: 261,
                y: 57,
                width: 990.0000000000043,
                height: 54,
                pushGraph: {
                  edges: [
                    {
                      distance: 0.75,
                      endNodeId: '9vux9ndrpy24jbiy4iuc9t5k7',
                      startNodeId: 'buffer_9vux9ndrpy24jbiy4iuc9t5k7',
                    },
                    {
                      distance: 1,
                      endNodeId: 'dk3rtqq8xd06vbkue3oynfnl0',
                      startNodeId: 'buffer_dk3rtqq8xd06vbkue3oynfnl0',
                    },
                    {
                      distance: 1,
                      endNodeId: '0x27jw14pzcftqj4zuajph9vf',
                      startNodeId: 'buffer_0x27jw14pzcftqj4zuajph9vf',
                    },
                  ],
                  nodeIds: [
                    '8t1zitypw7seplzhg9tghxanl',
                    'buffer_9vux9ndrpy24jbiy4iuc9t5k7',
                    '9vux9ndrpy24jbiy4iuc9t5k7',
                    'buffer_dk3rtqq8xd06vbkue3oynfnl0',
                    'dk3rtqq8xd06vbkue3oynfnl0',
                    'buffer_0x27jw14pzcftqj4zuajph9vf',
                    '0x27jw14pzcftqj4zuajph9vf',
                  ],
                },
              },
              opacity: 1,
              children: [
                {
                  x: 530.0000000000039,
                  y: 77.75,
                  id: '9vux9ndrpy24jbiy4iuc9t5k7',
                  name: null,
                  text: 'Product',
                  type: 'label',
                  color: '@background',
                  width: 291,
                  height: 19,
                  hidden: false,
                  mobile: {
                    x: 57.02051282051302,
                    y: 47.75,
                    width: 291,
                    height: 19,
                  },
                  shared: {
                    mobile: true,
                    tablet: true,
                    desktop: true,
                  },
                  tablet: {
                    x: 221.17266187050376,
                    y: 65.75,
                    width: 291,
                    height: 19,
                  },
                  actions: {},
                  desktop: {
                    x: 290.0000000000002,
                    y: 74.75,
                    width: 291,
                    height: 19,
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 16,
                  autoWidth: false,
                  fontStyle: 'normal',
                  // maxLength: null,
                  multiline: false,
                  fontFamily: '@body',
                  fontWeight: 500,
                  layoutText: ['Product'],
                  selectable: false,
                  positioning: 'fixedTop',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'FIXED',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'LEFT',
                  },
                  initialDevice: 'desktop',
                  textAlignment: 'left',
                },
                {
                  x: 807.2626262626352,
                  y: 78,
                  id: 'dk3rtqq8xd06vbkue3oynfnl0',
                  name: null,
                  text: 'Category',
                  type: 'label',
                  color: '@background',
                  width: 226.26262626262655,
                  height: 19,
                  hidden: false,
                  mobile: {
                    x: 268.0381403781384,
                    y: 48,
                    width: 200.6268717948709,
                    height: 19,
                  },
                  shared: {
                    mobile: true,
                    tablet: true,
                    desktop: true,
                  },
                  tablet: {
                    x: 623.8707652060216,
                    y: 66,
                    width: 318.93263570961255,
                    height: 19,
                  },
                  actions: {},
                  desktop: {
                    x: 640.0000000000043,
                    y: 75,
                    width: 279.99999999999886,
                    height: 19,
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 16,
                  autoWidth: false,
                  fontStyle: 'normal',
                  // maxLength: null,
                  multiline: false,
                  fontFamily: '@body',
                  fontWeight: 500,
                  layoutText: ['Category'],
                  selectable: false,
                  positioning: 'fixedTop',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'desktop',
                  textAlignment: 'left',
                },
                {
                  x: 1217.7676767676917,
                  y: 78,
                  id: '0x27jw14pzcftqj4zuajph9vf',
                  name: null,
                  text: 'In Stock',
                  type: 'label',
                  color: '@background',
                  width: 72.72727272726786,
                  height: 19,
                  hidden: false,
                  mobile: {
                    x: 589.750422170426,
                    y: 48,
                    width: 65.04699358974324,
                    height: 19,
                  },
                  shared: {
                    mobile: true,
                    tablet: false,
                    desktop: true,
                  },
                  tablet: {
                    x: 1172.9872518155894,
                    y: 65.75,
                    width: 116.99417266188004,
                    height: 19,
                    positioning: 'fixedTop',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  actions: {},
                  desktop: {
                    x: 1148.0000000000089,
                    y: 75,
                    width: 89.99999999999352,
                    height: 19,
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 16,
                  autoWidth: false,
                  fontStyle: 'normal',
                  // maxLength: null,
                  multiline: false,
                  fontFamily: '@body',
                  fontWeight: 500,
                  layoutText: ['In Stock'],
                  selectable: false,
                  positioning: 'fixedTop',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'desktop',
                  textAlignment: 'left',
                },
                {
                  x: 1050.4949494949583,
                  y: 77,
                  id: '8t1zitypw7seplzhg9tghxanl',
                  name: null,
                  text: 'Status',
                  type: 'label',
                  color: '@background',
                  width: 150.30303030302935,
                  height: 19,
                  hidden: false,
                  mobile: {
                    x: 458.6590002590008,
                    y: 47,
                    width: 141.06576923076784,
                    height: 19,
                  },
                  shared: {
                    mobile: true,
                    tablet: false,
                    desktop: true,
                  },
                  tablet: {
                    x: 965.9088937093297,
                    y: 65,
                    width: 162.3514099783058,
                    height: 19,
                    positioning: 'fixedTop',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  actions: {},
                  desktop: {
                    x: 941.0000000000025,
                    y: 74,
                    width: 185.99999999999773,
                    height: 19,
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 16,
                  autoWidth: false,
                  fontStyle: 'normal',
                  // maxLength: null,
                  multiline: false,
                  fontFamily: '@body',
                  fontWeight: 500,
                  layoutText: ['Status'],
                  selectable: false,
                  positioning: 'fixedTop',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'desktop',
                  textAlignment: 'left',
                },
              ],
              pushGraph: {
                edges: [
                  {
                    distance: 0.75,
                    endNodeId: '9vux9ndrpy24jbiy4iuc9t5k7',
                    startNodeId: 'buffer_9vux9ndrpy24jbiy4iuc9t5k7',
                  },
                  {
                    distance: 1,
                    endNodeId: 'dk3rtqq8xd06vbkue3oynfnl0',
                    startNodeId: 'buffer_dk3rtqq8xd06vbkue3oynfnl0',
                  },
                  {
                    distance: 1,
                    endNodeId: '0x27jw14pzcftqj4zuajph9vf',
                    startNodeId: 'buffer_0x27jw14pzcftqj4zuajph9vf',
                  },
                ],
                nodeIds: [
                  '8t1zitypw7seplzhg9tghxanl',
                  'buffer_9vux9ndrpy24jbiy4iuc9t5k7',
                  '9vux9ndrpy24jbiy4iuc9t5k7',
                  'buffer_dk3rtqq8xd06vbkue3oynfnl0',
                  'dk3rtqq8xd06vbkue3oynfnl0',
                  'buffer_0x27jw14pzcftqj4zuajph9vf',
                  '0x27jw14pzcftqj4zuajph9vf',
                ],
              },
              borderColor: '#BDBDBD',
              borderStyle: 'none',
              borderWidth: 1,
              positioning: 'fixedTop',
              borderRadius: 0,
              responsivity: {
                verticalScaling: 'FIXED',
                horizontalScaling: 'SCALES_WITH_PARENT',
                verticalPositioning: 'TOP',
                horizontalPositioning: 'CENTER',
              },
              initialDevice: 'desktop',
              borderPosition: 'center',
              backgroundColor: '@primaryDark',
              backgroundStyle: 'color',
              deviceVisibility: {
                mobile: false,
                tablet: true,
                desktop: true,
              },
            },
            {
              x: 517.1616161616166,
              y: 130,
              id: '8a3goj4fxsjrxw8qbu20s6y6j',
              name: 'List  39',
              type: 'list',
              width: 767.6767676767698,
              height: 206,
              hidden: false,
              mobile: {
                x: 89.16923076923105,
                y: 72,
                width: 1333.6615384615418,
                height: 417,
                pushGraph: {
                  edges: [
                    {
                      distance: 16,
                      endNodeId: '9zj9q94kib3vq374t2hctzbe8',
                      startNodeId: 'buffer_9zj9q94kib3vq374t2hctzbe8',
                    },
                    {
                      distance: 30,
                      endNodeId: 'ejkouuqrsmdhb6n57wwg063uf',
                      startNodeId: '9zj9q94kib3vq374t2hctzbe8',
                    },
                    {
                      distance: 15,
                      endNodeId: '4ngp8p5imw08az1mxuoi1ywfq',
                      startNodeId: '1p336pzvggesjjfgvdwf6znfr',
                    },
                    {
                      distance: 15,
                      endNodeId: '4ngp8p5imw08az1mxuoi1ywfq',
                      startNodeId: '9zj9q94kib3vq374t2hctzbe8',
                    },
                    {
                      distance: 23,
                      endNodeId: '4ad74z96wtf7cxgi33uz04sxk',
                      startNodeId: 'ejkouuqrsmdhb6n57wwg063uf',
                    },
                    {
                      distance: 23,
                      endNodeId: '4ad74z96wtf7cxgi33uz04sxk',
                      startNodeId: '4ngp8p5imw08az1mxuoi1ywfq',
                    },
                    {
                      distance: 23,
                      endNodeId: '6y1bhluyweilmv47nn4nwr4mx',
                      startNodeId: '4ngp8p5imw08az1mxuoi1ywfq',
                    },
                    {
                      distance: 19,
                      endNodeId: '3jys2c7b9jsuybhfwr8sstez5',
                      startNodeId: '4ad74z96wtf7cxgi33uz04sxk',
                    },
                    {
                      distance: 19,
                      endNodeId: '70xoarpee1fd0fqf21ngytl20',
                      startNodeId: '4ad74z96wtf7cxgi33uz04sxk',
                    },
                    {
                      distance: 19,
                      endNodeId: '70xoarpee1fd0fqf21ngytl20',
                      startNodeId: '6y1bhluyweilmv47nn4nwr4mx',
                    },
                    {
                      distance: 21,
                      endNodeId: 'cdcbcgpfay3xaf3ysf99kp7ru',
                      startNodeId: '3jys2c7b9jsuybhfwr8sstez5',
                    },
                    {
                      distance: 21,
                      endNodeId: 'cdcbcgpfay3xaf3ysf99kp7ru',
                      startNodeId: '70xoarpee1fd0fqf21ngytl20',
                    },
                  ],
                  nodeIds: [
                    '1p336pzvggesjjfgvdwf6znfr',
                    'buffer_9zj9q94kib3vq374t2hctzbe8',
                    '9zj9q94kib3vq374t2hctzbe8',
                    'ejkouuqrsmdhb6n57wwg063uf',
                    '4ngp8p5imw08az1mxuoi1ywfq',
                    '4ad74z96wtf7cxgi33uz04sxk',
                    '6y1bhluyweilmv47nn4nwr4mx',
                    '3jys2c7b9jsuybhfwr8sstez5',
                    '70xoarpee1fd0fqf21ngytl20',
                    'cdcbcgpfay3xaf3ysf99kp7ru',
                  ],
                },
                positioning: 'fixedTop',
                responsivity: {
                  verticalScaling: 'FIXED',
                  horizontalScaling: 'SCALES_WITH_PARENT',
                  verticalPositioning: 'TOP',
                  horizontalPositioning: 'CENTER',
                },
              },
              shared: {
                mobile: false,
                tablet: false,
                desktop: false,
              },
              tablet: {
                x: 215.74100719424473,
                y: 118,
                width: 1080.5179856115087,
                height: 250,
                pushGraph: {
                  edges: [
                    {
                      distance: 16,
                      endNodeId: '9zj9q94kib3vq374t2hctzbe8',
                      startNodeId: 'buffer_9zj9q94kib3vq374t2hctzbe8',
                    },
                    {
                      distance: 16,
                      endNodeId: 'ejkouuqrsmdhb6n57wwg063uf',
                      startNodeId: 'buffer_ejkouuqrsmdhb6n57wwg063uf',
                    },
                    {
                      distance: 16,
                      endNodeId: '4ad74z96wtf7cxgi33uz04sxk',
                      startNodeId: 'buffer_4ad74z96wtf7cxgi33uz04sxk',
                    },
                    {
                      distance: 16,
                      endNodeId: '3jys2c7b9jsuybhfwr8sstez5',
                      startNodeId: 'buffer_3jys2c7b9jsuybhfwr8sstez5',
                    },
                    {
                      distance: 19,
                      endNodeId: 'cdcbcgpfay3xaf3ysf99kp7ru',
                      startNodeId: '1p336pzvggesjjfgvdwf6znfr',
                    },
                    {
                      distance: 19,
                      endNodeId: 'cdcbcgpfay3xaf3ysf99kp7ru',
                      startNodeId: '9zj9q94kib3vq374t2hctzbe8',
                    },
                    {
                      distance: 19,
                      endNodeId: 'cdcbcgpfay3xaf3ysf99kp7ru',
                      startNodeId: 'ejkouuqrsmdhb6n57wwg063uf',
                    },
                    {
                      distance: 19,
                      endNodeId: 'cdcbcgpfay3xaf3ysf99kp7ru',
                      startNodeId: '4ad74z96wtf7cxgi33uz04sxk',
                    },
                    {
                      distance: 19,
                      endNodeId: 'cdcbcgpfay3xaf3ysf99kp7ru',
                      startNodeId: '3jys2c7b9jsuybhfwr8sstez5',
                    },
                  ],
                  nodeIds: [
                    '1p336pzvggesjjfgvdwf6znfr',
                    'buffer_9zj9q94kib3vq374t2hctzbe8',
                    '9zj9q94kib3vq374t2hctzbe8',
                    'buffer_ejkouuqrsmdhb6n57wwg063uf',
                    'ejkouuqrsmdhb6n57wwg063uf',
                    'buffer_4ad74z96wtf7cxgi33uz04sxk',
                    '4ad74z96wtf7cxgi33uz04sxk',
                    'buffer_3jys2c7b9jsuybhfwr8sstez5',
                    '3jys2c7b9jsuybhfwr8sstez5',
                    'cdcbcgpfay3xaf3ysf99kp7ru',
                  ],
                },
                positioning: 'fixedTop',
                responsivity: {
                  verticalScaling: 'FIXED',
                  horizontalScaling: 'SCALES_WITH_PARENT',
                  verticalPositioning: 'TOP',
                  horizontalPositioning: 'CENTER',
                },
              },
              actions: {},
              desktop: {
                x: 281.0000000000001,
                y: 124,
                width: 950.0000000000023,
                height: 223,
                pushGraph: {
                  edges: [
                    {
                      distance: 16,
                      endNodeId: '9zj9q94kib3vq374t2hctzbe8',
                      startNodeId: 'buffer_9zj9q94kib3vq374t2hctzbe8',
                    },
                    {
                      distance: 16,
                      endNodeId: 'ejkouuqrsmdhb6n57wwg063uf',
                      startNodeId: 'buffer_ejkouuqrsmdhb6n57wwg063uf',
                    },
                    {
                      distance: 16,
                      endNodeId: '4ad74z96wtf7cxgi33uz04sxk',
                      startNodeId: 'buffer_4ad74z96wtf7cxgi33uz04sxk',
                    },
                    {
                      distance: 16,
                      endNodeId: '3jys2c7b9jsuybhfwr8sstez5',
                      startNodeId: 'buffer_3jys2c7b9jsuybhfwr8sstez5',
                    },
                    {
                      distance: 9,
                      endNodeId: 'cdcbcgpfay3xaf3ysf99kp7ru',
                      startNodeId: '1p336pzvggesjjfgvdwf6znfr',
                    },
                    {
                      distance: 9,
                      endNodeId: 'cdcbcgpfay3xaf3ysf99kp7ru',
                      startNodeId: '9zj9q94kib3vq374t2hctzbe8',
                    },
                    {
                      distance: 9,
                      endNodeId: 'cdcbcgpfay3xaf3ysf99kp7ru',
                      startNodeId: 'ejkouuqrsmdhb6n57wwg063uf',
                    },
                    {
                      distance: 9,
                      endNodeId: 'cdcbcgpfay3xaf3ysf99kp7ru',
                      startNodeId: '4ad74z96wtf7cxgi33uz04sxk',
                    },
                    {
                      distance: 9,
                      endNodeId: 'cdcbcgpfay3xaf3ysf99kp7ru',
                      startNodeId: '3jys2c7b9jsuybhfwr8sstez5',
                    },
                  ],
                  nodeIds: [
                    '1p336pzvggesjjfgvdwf6znfr',
                    'buffer_9zj9q94kib3vq374t2hctzbe8',
                    '9zj9q94kib3vq374t2hctzbe8',
                    'buffer_ejkouuqrsmdhb6n57wwg063uf',
                    'ejkouuqrsmdhb6n57wwg063uf',
                    'buffer_4ad74z96wtf7cxgi33uz04sxk',
                    '4ad74z96wtf7cxgi33uz04sxk',
                    'buffer_3jys2c7b9jsuybhfwr8sstez5',
                    '3jys2c7b9jsuybhfwr8sstez5',
                    'cdcbcgpfay3xaf3ysf99kp7ru',
                  ],
                },
                positioning: 'fixedTop',
                responsivity: {
                  verticalScaling: 'FIXED',
                  horizontalScaling: 'SCALES_WITH_PARENT',
                  verticalPositioning: 'TOP',
                  horizontalPositioning: 'CENTER',
                },
              },
              masonry: true,
              opacity: 1,
              children: [
                {
                  x: 517.1616161616166,
                  y: 130,
                  id: '1p336pzvggesjjfgvdwf6znfr',
                  name: 'Image 50',
                  type: 'image',
                  width: 50,
                  height: 50,
                  hidden: false,
                  mobile: {
                    x: 89.16923076923105,
                    y: 72,
                    width: 50,
                    height: 50,
                  },
                  tablet: {
                    x: 215.74100719424473,
                    y: 118,
                    width: 50,
                    height: 50,
                  },
                  actions: {},
                  desktop: {
                    x: 281.0000000000001,
                    y: 124,
                    width: 50,
                    height: 50,
                  },
                  opacity: 1,
                  children: [],
                  imageType: 'uploaded',
                  pushGraph: {
                    edges: [],
                    nodeIds: [],
                  },
                  filename1x: {
                    url: '73d1ddbe9659b3c2038103939f80606ddf04a48c7e77af3f43377a56d7bc0d85.jpg',
                    filename: 'gradient.jpg',
                  },
                  borderColor: '#999',
                  borderStyle: 'none',
                  borderWidth: 1,
                  imageResize: 'cover',
                  positioning: 'fixedTop',
                  borderRadius: 12,
                  imageBinding: null,
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'FIXED',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'LEFT',
                  },
                  initialDevice: 'desktop',
                  backgroundColor: '#ddd',
                  backgroundStyle: 'none',
                },
                {
                  x: 587.289926289925,
                  y: 146,
                  id: '9zj9q94kib3vq374t2hctzbe8',
                  name: null,
                  text: 'Pickleball Racket ',
                  type: 'label',
                  color: '@text',
                  width: 208.74692874692983,
                  height: 19,
                  hidden: false,
                  mobile: {
                    x: 147.95986034463397,
                    y: 88,
                    width: 212,
                    height: 19,
                    positioning: 'fixedTop',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'FIXED',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'LEFT',
                    },
                  },
                  shared: {
                    mobile: false,
                    tablet: false,
                    desktop: false,
                  },
                  tablet: {
                    x: 333.3807662896462,
                    y: 134,
                    width: 274.1313948391505,
                    height: 19,
                    positioning: 'fixedTop',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  actions: {},
                  desktop: {
                    x: 367.7837837837864,
                    y: 140,
                    width: 258.3243243243222,
                    height: 19,
                    positioning: 'fixedTop',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 16,
                  autoWidth: false,
                  fontStyle: 'normal',
                  // maxLength: null,
                  multiline: false,
                  fontFamily: '@body',
                  // fontWeight: '400',
                  layoutText: ['...'],
                  selectable: false,
                  positioning: 'fixedTop',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'desktop',
                  textAlignment: 'left',
                },
                {
                  x: 808.0707070707106,
                  y: 146,
                  id: 'ejkouuqrsmdhb6n57wwg063uf',
                  name: null,
                  text: 'Sports Equipment',
                  type: 'label',
                  color: '@text',
                  width: 202.8282828282844,
                  height: 19,
                  hidden: false,
                  mobile: {
                    x: 179.9598603446342,
                    y: 137,
                    width: 181,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'FIXED',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'LEFT',
                    },
                  },
                  shared: {
                    mobile: false,
                    tablet: true,
                    desktop: true,
                  },
                  tablet: {
                    x: 625.2004543733459,
                    y: 134,
                    width: 285.4842256720947,
                    height: 19,
                  },
                  actions: {},
                  desktop: {
                    x: 641.0000000000038,
                    y: 140,
                    width: 251.00000000000182,
                    height: 19,
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 16,
                  autoWidth: false,
                  fontStyle: 'normal',
                  // maxLength: null,
                  multiline: false,
                  fontFamily: '@body',
                  // fontWeight: '400',
                  layoutText: ['...'],
                  selectable: false,
                  positioning: 'fixedTop',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'desktop',
                  textAlignment: 'left',
                },
                {
                  x: 1052.9191919191965,
                  y: 146,
                  id: '4ad74z96wtf7cxgi33uz04sxk',
                  name: null,
                  text: 'Active',
                  type: 'label',
                  color: '@text',
                  width: 80.80808080808072,
                  height: 19,
                  hidden: false,
                  mobile: {
                    x: 157.95986034463402,
                    y: 179,
                    width: 206,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'FIXED',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'LEFT',
                    },
                  },
                  shared: {
                    mobile: false,
                    tablet: true,
                    desktop: true,
                  },
                  tablet: {
                    x: 969.8288224157538,
                    y: 134,
                    width: 113.73873532752691,
                    height: 19,
                  },
                  actions: {},
                  desktop: {
                    x: 944.0000000000049,
                    y: 140,
                    width: 99.99999999999989,
                    height: 19,
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 16,
                  autoWidth: false,
                  fontStyle: 'normal',
                  // maxLength: null,
                  multiline: false,
                  fontFamily: '@body',
                  // fontWeight: '400',
                  layoutText: ['...'],
                  selectable: false,
                  positioning: 'fixedTop',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'desktop',
                  textAlignment: 'left',
                },
                {
                  x: 1216.9595959595972,
                  y: 146,
                  id: '3jys2c7b9jsuybhfwr8sstez5',
                  name: null,
                  text: '3',
                  type: 'label',
                  color: '@text',
                  width: 67.87878787878162,
                  height: 19,
                  hidden: false,
                  mobile: {
                    x: 172.95986034463408,
                    y: 217,
                    width: 190,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'FIXED',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'LEFT',
                    },
                  },
                  shared: {
                    mobile: false,
                    tablet: false,
                    desktop: false,
                  },
                  tablet: {
                    x: 1171.2429782944855,
                    y: 134,
                    width: 95.5405376751171,
                    height: 19,
                    positioning: 'fixedTop',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  actions: {},
                  desktop: {
                    x: 1146.9999999999923,
                    y: 140,
                    width: 83.99999999999466,
                    height: 19,
                    positioning: 'fixedTop',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 16,
                  autoWidth: false,
                  fontStyle: 'normal',
                  // maxLength: null,
                  multiline: false,
                  fontFamily: '@body',
                  // fontWeight: '400',
                  layoutText: ['...'],
                  selectable: false,
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'desktop',
                  textAlignment: 'left',
                },
                {
                  x: 517.1616161616166,
                  y: 189,
                  id: 'cdcbcgpfay3xaf3ysf99kp7ru',
                  name: 'Line 17',
                  type: 'line',
                  width: 767.6767676767812,
                  height: 1,
                  hidden: false,
                  mobile: {
                    x: 89.16923076923105,
                    y: 257,
                    width: 1333.6615384615582,
                    height: 1,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  shared: {
                    mobile: false,
                    tablet: false,
                    desktop: false,
                  },
                  tablet: {
                    x: 215.74100719424473,
                    y: 187,
                    width: 1080.517985611497,
                    height: 1,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  actions: {},
                  desktop: {
                    x: 281.0000000000001,
                    y: 183,
                    width: 950.0000000000124,
                    height: 1,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'SCALES_WITH_PARENT',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'CENTER',
                    },
                  },
                  opacity: 1,
                  children: [],
                  borderColor: '#e0e0e0',
                  borderStyle: 'solid',
                  borderWidth: 1,
                  positioning: 'fixed',
                  borderRadius: 0,
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'SCALES_WITH_PARENT',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'CENTER',
                  },
                  initialDevice: 'desktop',
                  borderPosition: 'center',
                  backgroundColor: 'rgba(255, 255, 255, 0)',
                  backgroundStyle: 'color',
                },
                {
                  x: 520.1616161616168,
                  y: 195,
                  id: '4ngp8p5imw08az1mxuoi1ywfq',
                  name: null,
                  text: 'Category:',
                  type: 'label',
                  color: '@text',
                  width: 83,
                  height: 19,
                  hidden: false,
                  mobile: {
                    x: 92.16923076923106,
                    y: 137,
                    width: 83,
                    height: 19,
                    positioning: 'fixedTop',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'FIXED',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'LEFT',
                    },
                  },
                  shared: {
                    mobile: false,
                    tablet: false,
                    desktop: false,
                  },
                  tablet: {
                    x: 121.5656565656559,
                    y: 116,
                    width: 83,
                    height: 19,
                    positioning: 'fixedTop',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'FIXED',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'LEFT',
                    },
                  },
                  actions: {},
                  desktop: {
                    x: 75.48015873015872,
                    y: 115,
                    width: 83,
                    height: 19,
                    positioning: 'fixedTop',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'FIXED',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'LEFT',
                    },
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 16,
                  autoWidth: false,
                  fontStyle: 'normal',
                  // maxLength: null,
                  multiline: true,
                  fontFamily: '@body',
                  // fontWeight: '700',
                  layoutText: [],
                  selectable: false,
                  positioning: 'fixedTop',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'FIXED',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'LEFT',
                  },
                  initialDevice: 'mobile',
                  textAlignment: 'left',
                  inResponsiveApp: true,
                  deviceVisibility: {
                    mobile: true,
                    tablet: false,
                    desktop: false,
                  },
                  calculatedFontFamily:
                    '-apple-system, "SF Pro Text", sans-serif',
                },
                {
                  x: 519.7501959566389,
                  y: 218,
                  id: '6y1bhluyweilmv47nn4nwr4mx',
                  name: null,
                  text: 'Status:',
                  type: 'label',
                  color: '@text',
                  width: 63,
                  height: 19,
                  hidden: false,
                  mobile: {
                    x: 91.75781056425296,
                    y: 179,
                    width: 63,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'FIXED',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'LEFT',
                    },
                  },
                  shared: {
                    mobile: false,
                    tablet: false,
                    desktop: false,
                  },
                  tablet: {
                    x: 121.15423636067783,
                    y: 119,
                    width: 63,
                    height: 19,
                    positioning: 'fixedTop',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'FIXED',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'LEFT',
                    },
                  },
                  actions: {},
                  desktop: {
                    x: 75.06873852518065,
                    y: 118,
                    width: 63,
                    height: 19,
                    positioning: 'fixedTop',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'FIXED',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'LEFT',
                    },
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 16,
                  autoWidth: false,
                  fontStyle: 'normal',
                  // maxLength: null,
                  multiline: true,
                  fontFamily: '@body',
                  // fontWeight: '700',
                  layoutText: [],
                  selectable: false,
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'FIXED',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'LEFT',
                  },
                  initialDevice: 'mobile',
                  textAlignment: 'left',
                  inResponsiveApp: true,
                  deviceVisibility: {
                    mobile: true,
                    tablet: false,
                    desktop: false,
                  },
                  calculatedFontFamily:
                    '-apple-system, "SF Pro Text", sans-serif',
                },
                {
                  x: 519.7501959566389,
                  y: 218,
                  id: '70xoarpee1fd0fqf21ngytl20',
                  name: null,
                  text: 'In Stock:',
                  type: 'label',
                  color: '@text',
                  width: 77,
                  height: 19,
                  hidden: false,
                  mobile: {
                    x: 91.75781056425296,
                    y: 217,
                    width: 77,
                    height: 19,
                    positioning: 'fixed',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'FIXED',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'LEFT',
                    },
                  },
                  shared: {
                    mobile: false,
                    tablet: false,
                    desktop: false,
                  },
                  tablet: {
                    x: 121.15423636067783,
                    y: 119,
                    width: 77,
                    height: 19,
                    positioning: 'fixedTop',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'FIXED',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'LEFT',
                    },
                  },
                  actions: {},
                  desktop: {
                    x: 75.06873852518065,
                    y: 118,
                    width: 77,
                    height: 19,
                    positioning: 'fixedTop',
                    responsivity: {
                      verticalScaling: 'FIXED',
                      horizontalScaling: 'FIXED',
                      verticalPositioning: 'TOP',
                      horizontalPositioning: 'LEFT',
                    },
                  },
                  opacity: 1,
                  children: [],
                  fontSize: 16,
                  autoWidth: false,
                  fontStyle: 'normal',
                  // maxLength: null,
                  multiline: true,
                  fontFamily: '@body',
                  // fontWeight: '700',
                  layoutText: [],
                  selectable: false,
                  positioning: 'fixed',
                  responsivity: {
                    verticalScaling: 'FIXED',
                    horizontalScaling: 'FIXED',
                    verticalPositioning: 'TOP',
                    horizontalPositioning: 'LEFT',
                  },
                  initialDevice: 'mobile',
                  textAlignment: 'left',
                  inResponsiveApp: true,
                  deviceVisibility: {
                    mobile: true,
                    tablet: false,
                    desktop: false,
                  },
                  calculatedFontFamily:
                    '-apple-system, "SF Pro Text", sans-serif',
                },
              ],
              pushGraph: {
                edges: [
                  {
                    distance: 16,
                    endNodeId: '9zj9q94kib3vq374t2hctzbe8',
                    startNodeId: 'buffer_9zj9q94kib3vq374t2hctzbe8',
                  },
                  {
                    distance: 16,
                    endNodeId: 'ejkouuqrsmdhb6n57wwg063uf',
                    startNodeId: 'buffer_ejkouuqrsmdhb6n57wwg063uf',
                  },
                  {
                    distance: 16,
                    endNodeId: '4ad74z96wtf7cxgi33uz04sxk',
                    startNodeId: 'buffer_4ad74z96wtf7cxgi33uz04sxk',
                  },
                  {
                    distance: 16,
                    endNodeId: '3jys2c7b9jsuybhfwr8sstez5',
                    startNodeId: 'buffer_3jys2c7b9jsuybhfwr8sstez5',
                  },
                  {
                    distance: 9,
                    endNodeId: 'cdcbcgpfay3xaf3ysf99kp7ru',
                    startNodeId: '1p336pzvggesjjfgvdwf6znfr',
                  },
                  {
                    distance: 9,
                    endNodeId: 'cdcbcgpfay3xaf3ysf99kp7ru',
                    startNodeId: '9zj9q94kib3vq374t2hctzbe8',
                  },
                  {
                    distance: 9,
                    endNodeId: 'cdcbcgpfay3xaf3ysf99kp7ru',
                    startNodeId: 'ejkouuqrsmdhb6n57wwg063uf',
                  },
                  {
                    distance: 9,
                    endNodeId: 'cdcbcgpfay3xaf3ysf99kp7ru',
                    startNodeId: '4ad74z96wtf7cxgi33uz04sxk',
                  },
                  {
                    distance: 9,
                    endNodeId: 'cdcbcgpfay3xaf3ysf99kp7ru',
                    startNodeId: '3jys2c7b9jsuybhfwr8sstez5',
                  },
                  {
                    distance: 5,
                    endNodeId: '4ngp8p5imw08az1mxuoi1ywfq',
                    startNodeId: 'cdcbcgpfay3xaf3ysf99kp7ru',
                  },
                  {
                    distance: 4,
                    endNodeId: '6y1bhluyweilmv47nn4nwr4mx',
                    startNodeId: '4ngp8p5imw08az1mxuoi1ywfq',
                  },
                  {
                    distance: 4,
                    endNodeId: '70xoarpee1fd0fqf21ngytl20',
                    startNodeId: '4ngp8p5imw08az1mxuoi1ywfq',
                  },
                ],
                nodeIds: [
                  '1p336pzvggesjjfgvdwf6znfr',
                  'buffer_9zj9q94kib3vq374t2hctzbe8',
                  '9zj9q94kib3vq374t2hctzbe8',
                  'buffer_ejkouuqrsmdhb6n57wwg063uf',
                  'ejkouuqrsmdhb6n57wwg063uf',
                  'buffer_4ad74z96wtf7cxgi33uz04sxk',
                  '4ad74z96wtf7cxgi33uz04sxk',
                  'buffer_3jys2c7b9jsuybhfwr8sstez5',
                  '3jys2c7b9jsuybhfwr8sstez5',
                  'cdcbcgpfay3xaf3ysf99kp7ru',
                  '4ngp8p5imw08az1mxuoi1ywfq',
                  '6y1bhluyweilmv47nn4nwr4mx',
                  '70xoarpee1fd0fqf21ngytl20',
                ],
              },
              rowMargin: 20,
              columnCount: 1,
              positioning: 'fixedTop',
              responsivity: {
                verticalScaling: 'FIXED',
                horizontalScaling: 'SCALES_WITH_PARENT',
                verticalPositioning: 'TOP',
                horizontalPositioning: 'CENTER',
              },
              deviceColumns: {
                mobile: {
                  listType: 'default',
                  rowMargin: 36,
                  columnCount: 1,
                },
                tablet: {
                  listType: 'default',
                  rowMargin: 20,
                  columnCount: 1,
                },
                desktop: {
                  listType: 'default',
                  rowMargin: 18,
                  columnCount: 1,
                },
              },
              initialDevice: 'desktop',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              columnBreakpoints: 'CUSTOM',
            },
          ],
          pushGraph: {
            edges: [
              {
                distance: 16,
                endNodeId: '8a3goj4fxsjrxw8qbu20s6y6j',
                startNodeId: '7011ou39h5wwv63sx0k07dem7',
              },
            ],
            nodeIds: ['7011ou39h5wwv63sx0k07dem7', '8a3goj4fxsjrxw8qbu20s6y6j'],
          },
          borderColor: '#e0e0e0',
          borderStyle: 'none',
          borderWidth: 1,
          positioning: 'fixedTop',
          borderRadius: 0,
          responsivity: {
            verticalScaling: 'FIXED',
            horizontalScaling: 'SCALES_WITH_PARENT',
            verticalPositioning: 'TOP',
            horizontalPositioning: 'CENTER',
          },
          initialDevice: 'desktop',
          borderPosition: 'center',
          backgroundColor: '@background',
          backgroundStyle: 'color',
        },
      ],
      pushGraph: {
        edges: [],
        nodeIds: ['3ga1q74te62s71v9j2avobo1t'],
      },
      borderColor: '#BDBDBD',
      borderStyle: 'none',
      borderWidth: 1,
      positioning: 'fixed',
      borderRadius: 0,
      responsivity: {
        verticalScaling: 'FIXED',
        horizontalScaling: 'SCALES_WITH_PARENT',
        verticalPositioning: 'TOP',
        horizontalPositioning: 'CENTER',
      },
      initialDevice: 'desktop',
      borderPosition: 'center',
      backgroundColor: '#e0e0e0',
      backgroundStyle: 'none',
    },
  ],
  pushGraph: {
    edges: [],
    nodeIds: ['esnwr18r5q0emmufvsyquw6nv'],
  },
  borderColor: '#e0e0e0',
  borderStyle: 'none',
  borderWidth: 1,
  imageResize: 'cover',
  positioning: 'fixedTop',
  borderRadius: 0,
  responsivity: {
    verticalScaling: 'FIXED',
    horizontalScaling: 'SCALES_WITH_PARENT',
    verticalPositioning: 'TOP',
    horizontalPositioning: 'LEFT_AND_RIGHT',
  },
  initialDevice: 'desktop',
  snappingRules: {
    lock: {
      left: 0,
      right: 0,
    },
    snap: true,
    snapType: 'screenEdge',
  },
  borderPosition: 'center',
  backgroundColor: '#f5f5f5',
  backgroundStyle: 'color',
}

export default tableListsInventoryTable
